import { Box, Button, Typography } from '@mui/material'
import GridViewIcon from '@mui/icons-material/GridView'

export default function LockdownKPIDashboardEmptyState({ onBrowse }) {
  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', gap: 2, p: 10,
      minHeight: 'calc(100vh - 52px)',
    }}>
      <Box sx={{
        width: 64, height: 64, borderRadius: 4,
        bgcolor: 'primary.light',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <GridViewIcon sx={{ fontSize: 32, color: 'primary.main' }} />
      </Box>

      <Typography variant="h6" fontWeight={600}>
        Select a Lockdown to begin
      </Typography>

      <Typography variant="body2" color="text.secondary" align="center" sx={{ maxWidth: 340, lineHeight: 1.6 }}>
        Choose a network lockdown to load its sites and visualise KPI trends across 2G, 3G, 4G and 5G.
      </Typography>

      <Button variant="contained" size="medium" onClick={onBrowse} sx={{ mt: 1, px: 4 }}>
        Browse Lockdowns
      </Button>
    </Box>
  )
}
